var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubformIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H16C17.1 18 18 17.1 18 16V4C18 2.9 17.1 2 16 2ZM16.5 4V7.20001H8.70001V3.5H15.9C16.3 3.5 16.5 3.8 16.5 4ZM4 3.5H7.20001V7.29999H3.39999V4C3.49999 3.8 3.8 3.5 4 3.5ZM3.5 16V8.70001H7.29999V16.5H4C3.8 16.5 3.5 16.3 3.5 16ZM16 16.5H8.79999V8.70001H16.6V15.9C16.5 16.3 16.3 16.5 16 16.5Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubformIcon);
export default __webpack_public_path__ + "static/media/subform-icon.e1623aa44dc7b096000a283a3b34227f.svg";
export { ForwardRef as ReactComponent };